/**
 * Gates the MiB plan-aware UI for Careers: the locked nav badge and the
 * "not available on your plan" placeholder. Front-end display gate only —
 * backend enforcement lives behind `olympus.jpcMiBCapabilities`.
 */
export const MIB_GATES_FLAG = 'hermes.jpcMiBGates'
